import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "14",
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.7538 2.15448C15.1656 2.42217 14.5398 2.59795 13.8982 2.67567C14.5776 2.25634 15.0823 1.60539 15.3193 0.842969C14.6866 1.22802 13.9915 1.49969 13.2654 1.64576C12.9669 1.31672 12.6028 1.05373 12.1967 0.873655C11.7905 0.693581 11.3512 0.600402 10.9069 0.600098C9.12279 0.600098 7.67606 2.08358 7.67606 3.91431C7.67606 4.17425 7.70363 4.42631 7.75877 4.66918C5.07274 4.53068 2.69128 3.21195 1.09621 1.20531C0.808587 1.71385 0.657945 2.28835 0.659036 2.87259C0.659036 4.02196 1.23011 5.03677 2.09657 5.63148C1.58233 5.61437 1.07997 5.47243 0.632779 5.21794V5.25864C0.632779 6.86488 1.74671 8.20461 3.2256 8.50787C2.94887 8.58631 2.66252 8.62566 2.37489 8.62471C2.16681 8.62471 1.96332 8.60502 1.7664 8.56564C2.17731 9.8824 3.37067 10.8408 4.78523 10.8664C4.12037 11.4043 3.35416 11.8032 2.53211 12.0392C1.71008 12.2752 0.848985 12.3436 0 12.2402C1.47029 13.2105 3.19301 13.7279 4.95458 13.7283C10.9003 13.7283 14.1509 8.6792 14.1509 4.29897C14.1509 4.15456 14.1476 4.01081 14.1424 3.86968C14.7738 3.40231 15.3219 2.81942 15.7538 2.15448Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}